import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

import { TransactionType } from '../services/types';

export type TransactionsSelectedFiltersType = 'fromDate' | 'toDate' | 'TransactionType';

export interface ITransactionsSelectedFilters {
  type: TransactionsSelectedFiltersType;
  value: TransactionType | string;
}

export type FiltersState = {
  transactionsFilters: ITransactionsSelectedFilters[];
};

const initState: FiltersState = {
  transactionsFilters: [],
};

export const useTransactionsFiltersStore = createStore({
  name: 'transactions-filter',
  devtools: isDevtoolsEnabled,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setTransactionsFilters: handler('transactionsFilters'),
  };
});
